<template>
  <popup
    :opened="isOpened"
    @close="$emit('close')"
  >
    <!-- Screen to ask a confirmation to close current evaluation -->
    <div v-if="isStepOne">
      <div class="mx-5 xl:mx-20 my-8 w-auto h-auto">
        <h3 class="mb-10">
          Clôturer l'évaluation
        </h3>

        <p class="text-indigo-600 text-lg text-center">
          En cliquant sur "Clôturer" vous ne pourrez plus modifier cette évaluation..
        </p>
        <p class="text-indigo-600 text-lg text-center">
          Vous pourrez la consulter dans l’historique des évaluations en date du {{ today }}.
        </p>

        <div class="flex justify-center w-full mt-10">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="CLÔTURER"
            :uppercase="true"
            icon="arrow-right_1"
            :right="true"
            type-shadow="shadow-pink"
            @clickAction="$emit('closeEval')"
          />
        </div>
      </div>
    </div>
    <!-- END Screen to ask a confirmation to close current evaluation -->

    <!-- Screen to confirm the close -->
    <div v-if="isStepTwo">
      <div class="mx-5 xl:mx-6 my-8 w-auto h-auto">
        <h3 class="mb-10 text-pink-600">
          Evaluation clôturée
        </h3>

        <p class="text-indigo-600 text-lg text-center">
          L’évaluation a bien été clôturée ! Vous pouvez la retrouver dans l'historique situé en bas de page.
        </p>
        <p class="text-indigo-600 text-lg text-center">
          Une cartographie a été créée et est désormais disponible et comparable dans cartographie individuelle.
        </p>

        <illustration
          name="basket"
          class="w-full my-10"
        />
      </div>
    </div>
    <!-- END Screen to confirm the close -->
  </popup>
</template>

<script>
import Popup from './../Popup.vue';
import ActionButton from './../ActionButton.vue';
import Illustration from './../Illustration.vue';

export default {
  components:{
    Popup,
    ActionButton,
    Illustration,
  },

  props:{
    isOpened: Boolean,
    isStepOne: Boolean,
    isStepTwo: Boolean,
    today: String
  },
};
</script>